module.exports = __webpack_public_path__ + "img/brand6.95cfa298.png";